export enum Role {
  Authority = 'Authority',
  Provider = 'Provider',
  Administrator = 'Administrator',
  Organisation_administrator = 'organisation_administrator',
  Agreement_administrator = 'agreement_administrator',
  Provider_administrator = 'provider_administrator',
  Route_administrator = 'route_administrator',
  Route_supporter ='route_supporter',
  Kombit_administrator = 'kombit_administrator',
  Kombit_supporter = 'kombit_supporter',
  //Route_administrator = 'route_manager',
  None = 'none'
}